export default {
  ADD: 'add',
  REMOVE: 'remove',
  REPLACE: 'replace'
};
